import { useCallback } from "react"

import { addDate, newDateByJstParams } from "@/utils/date"
import {
	getJstDate,
	getJstDay,
	getJstFullYear,
	getJstHours,
	getJstMinute,
	getJstMonth,
	getJstTwoDigitDateStr,
	getJstTwoDigitMonthStr,
} from "@/utils/jst_date"

export const getMMDD = (date: Date) => {
	return `${getJstTwoDigitMonthStr(date)}/${getJstTwoDigitDateStr(date)}`
}

export const isSaturday = (date: Date) => {
	return getJstDay(date) === 6
}

export const isSunday = (date: Date) => {
	return getJstDay(date) === 0
}

export const getDayColor = (date: Date) => {
	if (isSaturday(date)) {
		return "#4567BB"
	} else if (isSunday(date)) {
		return "#DD3E3E"
	} else {
		return "#333333"
	}
}

export class HourMinute {
	private date: Date
	hour: number
	minute: number

	constructor(hour: number, minute: number) {
		const now = new Date()
		this.date = newDateByJstParams(
			getJstFullYear(now),
			getJstMonth(now),
			getJstDate(now),
			hour,
			minute
		)
		this.hour = hour
		this.minute = minute
	}

	// overflowする可能性があることに注意。その場合例外は投げない
	// willAddingMinuteOverflowでoverflowを確認可能
	addMinute(minute: number): HourMinute {
		const newDate = new Date(this.date.getTime() + minute * 60 * 1000)
		return new HourMinute(getJstHours(newDate), getJstMinute(newDate))
	}

	willAddingMinuteOverflow(minute: number): boolean {
		const newDate = new Date(this.date.getTime() + minute * 60 * 1000)
		return getJstDate(newDate) !== getJstDate(this.date)
	}

	less(hourMinute: HourMinute) {
		return (
			this.hour < hourMinute.hour ||
			(this.hour === hourMinute.hour && this.minute < hourMinute.minute)
		)
	}

	toString() {
		return (
			String(this.hour).padStart(2, "0") +
			":" +
			String(this.minute).padStart(2, "0")
		)
	}

	formatHourMinuteObj(): string {
		return `${this.hour.toString().padStart(2, "0")}:${this.minute
			.toString()
			.padStart(2, "0")}`
	}
	// なぜかうごかない...
	// equals(hourMinute: HourMinute) {
	//   return this.hour === hourMinute.hour && this.minute === hourMinute.minute;
	// }

	// lessOrEquals(hourMinute: HourMinute) {
	//   return this.less(hourMinute) || this.equals(hourMinute);
	// }
}

export const useWeekNavigation = (
	sevenDays: Date[],
	loadChunksFrom: (fromDate: Date) => void,
	setSevenDaysFrom: (sevenDaysFrom: Date) => void,
	sendPrevSevenDaysEvent: (startTime: Date) => void,
	sendNextSevenDaysEvent: (startTime: Date) => void
) => {
	const nextSevenDays = useCallback(() => {
		const nextFirstDate = addDate(sevenDays[6], 1)
		loadChunksFrom(nextFirstDate)
		setSevenDaysFrom(nextFirstDate)
		sendNextSevenDaysEvent(nextFirstDate)
	}, [sevenDays, loadChunksFrom, setSevenDaysFrom, sendNextSevenDaysEvent])

	const prevSevenDays = useCallback(() => {
		const prevFirstDate = addDate(sevenDays[0], -7)
		loadChunksFrom(prevFirstDate)
		setSevenDaysFrom(prevFirstDate)
		sendPrevSevenDaysEvent(prevFirstDate)
	}, [sevenDays, loadChunksFrom, setSevenDaysFrom, sendPrevSevenDaysEvent])

	return { nextSevenDays, prevSevenDays }
}
